const authRoles = {
	admin: ['Admin'],
	reviewer: ['Reviewer'],
	userProfile: ['UserProfile'],
	userAccount: ['UserAccount'],
	userRole: ['UserRole'],
	szervezo: ['Szervezo'],
	vizsgaztato: ['Vizsgaztato'],
	onlyGuest: []
};

export default authRoles;
export { authRoles };
